import { render } from "./StudentGrantForm.vue?vue&type=template&id=0cec0012&scoped=true"
import script from "./StudentGrantForm.vue?vue&type=script&lang=js"
export * from "./StudentGrantForm.vue?vue&type=script&lang=js"

import "./StudentGrantForm.vue?vue&type=style&index=0&id=0cec0012&scoped=true&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cec0012"]])

export default __exports__